import React from 'react'
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded' // country
import AccessAlarmRoundedIcon from '@mui/icons-material/AccessAlarmRounded' // duration
import FastfoodRoundedIcon from '@mui/icons-material/FastfoodRounded' // calories
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded' // cost
import FitnessCenterRoundedIcon from '@mui/icons-material/FitnessCenterRounded' // difficulty



export default function RecipeDetails({recipe}) {
  return (
    <div id='details_container'>
        <div id='details_row_1'> {/* row 1  => row */}
            <div id='details_country'> {/* row */}
                <LanguageRoundedIcon className='details_icons'/> 
                <p>{recipe.country}</p>
            </div>
            <div id='details_difficulty'>
                <FitnessCenterRoundedIcon className='details_icons'/>
                <p>{recipe.difficulty}</p>
            </div>
            <div id='details_duration'>
                <AccessAlarmRoundedIcon className='details_icons'/>
                <p>{recipe.duration}min</p>
            </div>
            <div id='details_calories'>
                <FastfoodRoundedIcon className='details_icons'/>
                <p>{recipe.calories}kCal</p>
            </div>
            <div id='details_cost'>
                <AttachMoneyRoundedIcon className='details_icons'/>
                <p>${recipe.cost}</p>
            </div>
        </div>
        <div id='details_row_2'>
            <div id='details_description'>
                <p>"{recipe.description}"</p>
            </div>
        </div>
        <div id='details_row_3'> {/* row 2 => row */}
            <div id='details_ingredients'>
                <h3>Ingredients for 2</h3>
                <div>
                    {recipe.ingredients.map((ingredient, i) => (
                        <p className='details_ingredient' key={`${i}`} >{ingredient.name}: {ingredient.quantity}<span>  /  </span> </p>
                    ))}
                </div>
            </div>
            <div id='details_utensils'>
                <h3>Utensils</h3>
                <div>
                    {recipe.utensils.map((utensil, i) => (
                        <p className='details_utensil' key={`${i}`} >{utensil}</p>
                    ))}
                </div>
            </div>
        </div>
        <div id='details_row_3'> {/* row 3 => column */}
            <div>{recipe.instructions}</div>
            
            <div>{recipe.origin}</div>
        </div>
    </div>
  )
}
